import { Box,Accordion, AccordionButton, AccordionItem, AccordionPanel, } from '@chakra-ui/react'
import React from 'react'
import {BsPlusCircle} from 'react-icons/bs'
import {FiMinusCircle} from 'react-icons/fi'

function MarketingPageAccordation({data}) {
  return (
    <Box >
        <Accordion allowMultiple  borderBottom="1px solid grey" borderTop="1px solid grey">
            {data.map((item)=>(
            <AccordionItem _hover={{color:"teal"}}>
                {({ isExpanded }) => (
                <>
                    <h2>
                    <AccordionButton>
                        <Box fontSize="24px" flex='1' p="1rem 1rem" textAlign='left'>
                        {item.que}
                        </Box>
                        {isExpanded ? (
                        <FiMinusCircle fontSize='28px' />
                        ) : (
                        <BsPlusCircle fontSize='28px' />
                        )}
                    </AccordionButton>
                    </h2>
                    <AccordionPanel ml="-16rem" pb="4">
                       <Box display="flex" fontSize="18px" justifyContent="left" w="50%" textAlign="left">{item.ans}</Box> 
                    </AccordionPanel>
                </>
                )}
            </AccordionItem>
            ))}
        </Accordion>
    </Box>
  )
}

export default MarketingPageAccordation